import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { Dropdown, DropdownButton } from "react-bootstrap";

import { useStore } from "../../store";
import Util from "../../helpers/util";
import Language from "../../helpers/language";
import { Drip7Modal } from "../../modals/drip7_modal";
import { BadgeModal } from "../../modals/admin/badge_modal";
import { BadgeAssignModal } from "../../modals/admin/badge_assign_modal";

import { ConfirmModal } from "../../modals/confirm_modal";

//State wrapper
const withStore = BaseComponent => props => {
    const { usr_info } = useStore(state => ({ usr_info: state.usr_info }));
    return <BaseComponent {...props} usr_info={usr_info} />;
};

class Klass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            badges_selected: {},
            badges: [],
            show_create_badge: false,
            show_assign_badge: false,
            confirm: null,
            search: "",
            sort_by: "",
            sort_by_reverse: false
        };

        this.updateBadgeList = this.updateBadgeList.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleShowCreate = this.handleShowCreate.bind(this);
        this.handleSelectBadge = this.handleSelectBadge.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleViewBadge = this.handleViewBadge.bind(this);
        this.handleAssignBadge = this.handleAssignBadge.bind(this)
        this.handleRemoveBadge = this.handleRemoveBadge.bind(this);
        this.handleSortBy = this.handleSortBy.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.onPathChange("badges");
        this.updateBadgeList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.tenant_uid != this.props.tenant_uid) {
            this.updateBadgeList();
        }
    }

    filterBadges(search, badges) {
        //Do nothing
        if (search == "") {
            return badges;
        }

        //Only keep
        let result = [];
        const search_lc = search.toLowerCase();
        for (let i = 0; i < badges.length; i++) {
            const badge = badges[i];
            if (
                badge.name.toLowerCase().indexOf(search_lc) >= 0 ||
                badge.tenant_name.toLowerCase().indexOf(search_lc) >= 0
            ) {
                result.push(badge);
            }
        }

        return result;
    }

    updateBadgeList() {
        const { tenant_uid, showToast } = this.props;

        //Get a list of all badges for this tenant
        Util.fetch_js( "/badge/list/", { tenant_uid },
            js => {
                let badges = [];
                js.badges.forEach(x => {
                    let b = x;
                    b["tenant_name"] = b.tenant.name;
                    badges.push(b);
                });
                this.setState({ badges });
            },
            (reason, code) => {
                showToast(reason, 'failure');
            }
        );
    }

    handleSortBy(code) {
        const { sort_by, sort_by_reverse } = this.state;
        const sbr = sort_by == code ? !sort_by_reverse : false;

        this.setState({ sort_by: code, sort_by_reverse: sbr });
    }

    handleRemoveBadge() {
        const { showToast } = this.props;
        let { badges_selected, badges } = this.state;

        const uids = Object.keys(badges_selected);

        Util.fetch_js(
            "/badge/remove/",
            { badge_uids: uids },
            js => {
                this.updateBadgeList();
                this.setState({ badges_selected: {} });
            },
            (reason, code) => {
                showToast(reason, 'failure');
            }
        );
        this.setState({ confirm: null });
    }

    handleModalClose() {
        this.updateBadgeList();
        this.setState({ show_create_badge: false, show_assign_badge: false });
    }

    handleShowCreate() {
        this.setState({ show_create_badge: true });
    }

    handleSelectBadge(checked, uid) {
        let { badges_selected } = this.state;

        if (checked) {
            badges_selected[uid] = true;
        }
        else {
            delete badges_selected[uid];
        }

        this.setState({ badges_selected });
    }

    handleSelectAll(checked) {
        const { search } = this.state;

        const badges = this.filterBadges(search, this.state.badges);
        let badges_selected = {};

        //Should we check or send empty list?
        if (checked) {
            for (let i = 0; i < badges.length; i++) {
                badges_selected[badges[i].uid] = true;
            }
        }

        this.setState({ badges_selected });
    }

    handleViewBadge(badge) {
        this.setState({ show_create_badge: badge });
    }

    handleAssignBadge(badge) {
        this.setState({ show_assign_badge: badge, show_create_badge: false })
    }

    handleChange(e) {
        this.setState({ [e.target.id]: e.target.value });
    }

    render() {
        const { tenant_uid, tenants, showToast } = this.props;
        const {
            badges,
            badges_selected,
            search,
            sort_by,
            sort_by_reverse,
            show_create_badge,
            show_assign_badge,
            confirm
        } = this.state;
        const selected_count = Object.keys(badges_selected).length;

        let filtered_badges = this.filterBadges(search, badges);

        //Sort?
        if (sort_by != "") {
            if (!sort_by_reverse) {
                filtered_badges.sort((a, b) =>
                    a[sort_by]
                        .toLowerCase()
                        .localeCompare(b[sort_by].toLowerCase())
                );
            }
            else {
                filtered_badges.sort((a, b) =>
                    b[sort_by]
                        .toLowerCase()
                        .localeCompare(a[sort_by].toLowerCase())
                );
            }
        }

        const confirmAction = action => {
            let yes = null;
            let msg = null;
            if (action == this.handleRemoveBadge) {
                yes = Language.getTitleCase('remove');
                msg = Language.getSentenceCase('remove badges?');
            }
            else {
                throw Language.getSentenceCase('Program error, Unknown action') + ": " + action;
            }

            //Setting a confirm action, will load message box, and if accepted saves
            const new_confirm = { action, msg, yes, no: Language.getTitleCase('cancel') };
            this.setState({ ...this.state, confirm: new_confirm });
        };

        return (
            <div className='badges-page main-modal'>
                <nav className='central__nav'>
                <ul className="central__nav-list">
                            <li className="central__nav-item central__nav-item--small central__nav-item--selected">
                                <svg width="15" height="15" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill='var(--drip7-primary-color)' d="M31.0314 31.5926C31.9786 31 32.2701 29.3704 33.0716 28.4815C33.946 27.6667 35.549 27.4444 36.1319 26.4074C36.7148 25.3704 36.1319 23.8148 36.4234 22.6296C36.7148 21.5185 37.9535 20.4815 37.9535 19.2222C37.9535 18.037 36.6419 17 36.3505 15.8889C36.059 14.7037 36.6419 13.1481 36.059 12.1111C35.4761 11.0741 33.8731 10.8519 33.0716 10.037C32.1972 9.14815 31.9786 7.51852 30.9585 6.92593C29.9384 6.33333 28.4083 6.92593 27.2425 6.62963C26.2224 6.33333 25.2023 5 24.0364 5C22.7977 5 21.7776 6.33333 20.6847 6.62963C19.5188 6.92593 17.9887 6.33333 16.9686 6.92593C16.0214 7.51852 15.7299 9.14815 14.9284 10.037C14.054 10.8519 12.451 11.0741 11.8681 12.1111C11.2852 13.1481 11.8681 14.7037 11.5766 15.8889C11.2852 17 10.0465 18.037 10.0465 19.2222C10.0465 20.4815 11.2852 21.5185 11.5766 22.6296C11.8681 23.8148 11.2852 25.3704 11.8681 26.4074C12.451 27.3704 14.054 27.6667 14.9284 28.4815C15.7299 29.3704 15.9485 31 16.9686 31.5926C17.9887 32.1852 19.5188 31.5926 20.6847 31.8889C21.7776 32.1852 22.7977 33.4444 24.0364 33.4444C25.2023 33.4444 26.2224 32.1852 27.3153 31.8889C28.4812 31.5926 30.0113 32.1852 31.0314 31.5926ZM18.2073 19.2222C18.2073 15.963 20.7575 13.2963 24.0364 13.2963C27.2425 13.2963 29.8656 15.963 29.8656 19.2222C29.8656 22.5556 27.2425 25.1481 24.0364 25.1481C20.7575 25.1481 18.2073 22.5556 18.2073 19.2222ZM10.1194 37.1481C9.90077 37.7407 9.97363 38.4074 10.4108 38.9259C10.848 39.4444 11.5038 39.6667 12.0867 39.5185L15.3656 38.8519L16.9686 41.963C17.2601 42.5556 17.843 42.9259 18.4988 42.9259C18.5716 42.9259 18.5716 42.9259 18.5716 42.9259C19.3003 42.9259 19.8832 42.4815 20.1018 41.8889L22.5791 35.8148C18.6445 35.4444 15.147 33.6667 12.5239 31.0741L10.1194 37.1481ZM35.4761 31.0741C32.853 33.6667 29.3555 35.4444 25.4209 35.8148L27.8254 41.8889C28.1168 42.4815 28.6997 42.9259 29.4284 43C29.4284 42.9259 29.4284 42.9259 29.5012 42.9259C30.157 42.9259 30.7399 42.6296 31.0314 41.963L32.6344 38.8519L35.9133 39.5185C36.4962 39.6667 37.152 39.4444 37.5892 38.9259C38.0264 38.4074 38.0992 37.7407 37.8806 37.1481L35.4761 31.0741Z" />
                                </svg>
                                {Language.getTitleCase('badge list')}
                            </li>
                        </ul>                       
                </nav>

                <div className='central__main'>
                    <div className='central__head'>
                        <div className='central__head-search-wrapper'>
                            <svg
                                width='15'
                                height='16'
                                viewBox='0 0 15 16'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'>
                                <path
                                    d='M14.8828 14.6152L11.3379 11.0703C11.25 11.0117 11.1621 10.9531 11.0742 10.9531H10.6934C11.6016 9.89844 12.1875 8.49219 12.1875 6.96875C12.1875 3.62891 9.43359 0.875 6.09375 0.875C2.72461 0.875 0 3.62891 0 6.96875C0 10.3379 2.72461 13.0625 6.09375 13.0625C7.61719 13.0625 8.99414 12.5059 10.0781 11.5977V11.9785C10.0781 12.0664 10.1074 12.1543 10.166 12.2422L13.7109 15.7871C13.8574 15.9336 14.0918 15.9336 14.209 15.7871L14.8828 15.1133C15.0293 14.9961 15.0293 14.7617 14.8828 14.6152ZM6.09375 11.6562C3.48633 11.6562 1.40625 9.57617 1.40625 6.96875C1.40625 4.39062 3.48633 2.28125 6.09375 2.28125C8.67188 2.28125 10.7812 4.39062 10.7812 6.96875C10.7812 9.57617 8.67188 11.6562 6.09375 11.6562Z'
                                    fill='currentColor'
                                />
                            </svg>
                            <input
                                type='text'
                                className='central__head-search rounded-md border-gray-200 bg-white text-gray-900 placeholder-text-gray-400 focus:border-drip7 focus:ring-0 sm:text-sm sm:leading-6'
                                placeholder={Language.getSentenceCase('Search badge words') + '...'}
                                aria-label='Search badge words'
                                id='search'
                                value={search}
                                onChange={this.handleChange}
                            />
                        </div>

                        <div className='central__head-button-container'>
                            {selected_count > 0 && (
                                <div className='selected-users-buttons'>
                                    <button
                                        type='button'
                                        className='central__head-button central__head-button--remove'
                                        name='remove-user'
                                        onClick={() =>
                                            confirmAction(
                                                this.handleRemoveBadge
                                            )
                                        }>
                                        {(selected_count != 1 ? Language.getTitleCase('Remove badges') : Language.getTitleCase('Remove badge'))}
                                    </button>
                                </div>
                            )}
                            <button
                                type='button'
                                className='central__head-button central__head-button--solid'
                                name='add-user'
                                onClick={this.handleShowCreate}>
                                {Language.getTitleCase('create badge')}
                            </button>
                        </div>
                    </div>

                    <div className='table__container'>
                        {confirm != null && (
                            <ConfirmModal
                                msg={confirm.msg}
                                yesTxt={confirm.yes}
                                noTxt={confirm.no}
                                onYes={() => confirm.action(true)}
                                onNo={() =>
                                    this.setState({
                                        ...this.state,
                                        confirm: null
                                    })
                                }
                            />
                        )}
                        <table className='table table--badges'>
                            <tbody>
                                <tr className='table__row table__row--head'>
                                    <th className='table__head table__head--checkbox'>
                                        <div className='d7__checkbox-container'>
                                            <input
                                                className='d7__checkbox'
                                                
                                                type='checkbox'
                                                aria-label="checkbox"
                                                onChange={event =>
                                                    this.handleSelectAll(
                                                        event.target.checked
                                                    )
                                                }
                                            />
                                            <span className='dash'></span>
                                        </div>
                                    </th>
                                    <th
                                        className='table__head table__head--name'
                                        id='badge_name'
                                        onClick={() =>
                                            this.handleSortBy("name")
                                        }>
                                        <div className="inline-flex">
                                            {Language.getTitleCase('name') + " "}
                                            <svg
                                                className='sort-btn'
                                                width='10'
                                                height='13'
                                                viewBox='0 0 10 13'
                                                fill='none'
                                                xmlns='http://www.w3.org/2000/svg'>
                                                <path
                                                    d='M1.51367 7.3125C0.869141 7.3125 0.546875 8.07422 1.01562 8.51367L4.50195 12C4.76562 12.293 5.20508 12.293 5.49805 12L8.98438 8.51367C9.42383 8.07422 9.10156 7.3125 8.48633 7.3125H1.51367ZM8.98438 4.23633L5.49805 0.75C5.20508 0.486328 4.76562 0.486328 4.50195 0.75L1.01562 4.23633C0.546875 4.70508 0.869141 5.4375 1.51367 5.4375H8.48633C9.10156 5.4375 9.42383 4.70508 8.98438 4.23633Z'
                                                    fill='#CFD8DD'
                                                />
                                            </svg>
                                        </div>
                                    </th>
                                    <th
                                        className='table__head table__head--name'
                                        id='tenant_owner'
                                        onClick={() =>
                                            this.handleSortBy("tenant_name")
                                        }>
                                        <div className="inline-flex">
                                            {Language.getTitleCase('tenant owner') + " "}
                                            <svg
                                                className='sort-btn'
                                                width='10'
                                                height='13'
                                                viewBox='0 0 10 13'
                                                fill='none'
                                                xmlns='http://www.w3.org/2000/svg'>
                                                <path
                                                    d='M1.51367 7.3125C0.869141 7.3125 0.546875 8.07422 1.01562 8.51367L4.50195 12C4.76562 12.293 5.20508 12.293 5.49805 12L8.98438 8.51367C9.42383 8.07422 9.10156 7.3125 8.48633 7.3125H1.51367ZM8.98438 4.23633L5.49805 0.75C5.20508 0.486328 4.76562 0.486328 4.50195 0.75L1.01562 4.23633C0.546875 4.70508 0.869141 5.4375 1.51367 5.4375H8.48633C9.10156 5.4375 9.42383 4.70508 8.98438 4.23633Z'
                                                    fill='#CFD8DD'
                                                />
                                            </svg>
                                        </div>
                                    </th>
                                    <th className='table__head table__head--img' id='tenant_image'>
                                        {Language.getTitleCase('image') + " "}
                                        <div className="inline-flex">
                                            <svg
                                                className='sort-btn'
                                                alt="sort"
                                                width='10'
                                                height='13'
                                                viewBox='0 0 10 13'
                                                fill='none'
                                                xmlns='http://www.w3.org/2000/svg'>
                                                <path
                                                    d='M1.51367 7.3125C0.869141 7.3125 0.546875 8.07422 1.01562 8.51367L4.50195 12C4.76562 12.293 5.20508 12.293 5.49805 12L8.98438 8.51367C9.42383 8.07422 9.10156 7.3125 8.48633 7.3125H1.51367ZM8.98438 4.23633L5.49805 0.75C5.20508 0.486328 4.76562 0.486328 4.50195 0.75L1.01562 4.23633C0.546875 4.70508 0.869141 5.4375 1.51367 5.4375H8.48633C9.10156 5.4375 9.42383 4.70508 8.98438 4.23633Z'
                                                    fill='#CFD8DD'
                                                />
                                            </svg>
                                        </div>
                                    </th>
                                </tr>
                                {Object.entries(filtered_badges).map(
                                    ([key, badge]) => (
                                        <tr
                                            className='table__row'
                                            key={"badge_tr_" + key}>
                                            <td className='user-table-select'>
                                                <div className='d7__checkbox-container'>
                                                    <input
                                                        type='checkbox'
                                                        aria-label="checkbox"
                                                        onChange={event =>
                                                            this.handleSelectBadge(
                                                                event.target
                                                                    .checked,
                                                                badge.uid
                                                            )
                                                        }
                                                        checked={
                                                            badge.uid in
                                                            badges_selected
                                                        }
                                                    />
                                                    <span className='checkmark'></span>
                                                </div>
                                            </td>
                                            <td
                                                className='table__data table__data--img-name'
                                                header='badge_name'
                                                onClick={() =>
                                                    this.handleViewBadge(badge)
                                                }>
                                                {badge.name}
                                            </td>
                                            <td
                                                className='table__data table__data--img-name'
                                                header='tenant_owner'
                                                onClick={() =>
                                                    this.handleViewBadge(badge)
                                                }>
                                                {badge.tenant_name}
                                            </td>
                                            <td
                                                className='table__data table__data--img'
                                                header='tenant_image'
                                                onClick={() =>
                                                    this.handleViewBadge(badge)
                                                }>
                                                <img
                                                    className='badge-placeholder'
                                                    src={badge.image}
                                                    alt={`badge image for ${badge.name}`}
                                                />
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <Drip7Modal>
                    {show_create_badge && (
                        <BadgeModal
                            badge={show_create_badge}
                            tenant_uid={tenant_uid}
                            tenants={tenants}
                            showToast={showToast}
                            onClose={this.handleModalClose}
                            onAssign={this.handleAssignBadge}
                            badges={badges}
                        />
                    )}

                    {show_assign_badge && (
                        <BadgeAssignModal
                            badge={show_assign_badge}
                            tenant_uid={tenant_uid}
                            tenants={tenants}
                            showToast={showToast}
                            onClose={this.handleModalClose}
                            badges={badges}
                        />
                    )}
                </Drip7Modal>
            </div>
        );
    }
}

export const Badges = withStore(Klass);
